// extracted by mini-css-extract-plugin
export default {"mobileMinWidth":"0","mobileMaxWidth":"767px","tabletMinWidth":"768px","tabletMaxWidth":"1259px","desktopMinWidth":"1260px","desktopMaxWidth":"5120px"};